<div class="doc-row" [class.ok]="!critical" [class.crit]="critical">
  <div class="doc-info">
    <strong>{{ title || fileName }}</strong>
    <span class="doc-meta" [class.crit]="critical">{{ meta || label || 'caricato' }}</span>
  </div>
  <span class="doc-stato" [class.ok]="!critical" [class.crit]="critical">{{ status || 'caricato' }}</span>
  <div class="doc-actions">
    <button type="button" class="doc-btn" (click)="onDocumento((file || '').toString())">Apri</button>
    <button type="button" class="doc-btn doc-btn-danger" [pTooltip]="tooltip || 'Rimuovi'" tooltipPosition="bottom" (click)="onOpenDelete($event)">Rimuovi</button>
  </div>
</div>
<p-confirmpopup>
  <ng-template pTemplate="headless" let-message>
    <div class="border-round p-3">
      <span class="text-base">{{ message.message }}</span>
      <div class="flex align-items-center gap-2 mt-3">
        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onCloseDelete()">Annulla</button>
        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()">Elimina</button>
      </div>
    </div>
  </ng-template>
</p-confirmpopup>
